// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"Logo_titleWrapper___chwB","logo":"Logo_logo__MLmTN","title":"Logo_title__Z9M3t"};